import React, { Component } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import { connect } from 'react-redux';
import { compose } from 'redux';

import logo from '../images/logo.svg';

class Footer extends Component {

	componentDidMount() {
		this.props.setRecaptcha(this.recaptcha);
	}

	render() {
		return (
            <footer className="footer">
				<a href="https://plazaro.com" target="_blank" rel="noopener noreferrer">
					<img src={logo} alt="Plazaro" className="footer__logo" />
				</a>

				<br />

				<ReCAPTCHA
					ref={(el) => this.recaptcha = el }
					size="invisible"
					sitekey={this.props.recaptchaSiteKey}
					onChange={this.props.recaptchaDidResolve}
				/>
            </footer>
		);
	}
}

export default compose(
	connect((state) => ({
		recaptchaSiteKey: state.app.recaptcha
	}))
)(Footer);



// WEBPACK FOOTER //
// ./src/components/Footer.jsx